import { useIsRouteActive } from '@luminovo/design-system';

/** Whether the page on screen is below `/next`, in the new navigation, for a page that both trees share. */
export function useIsInNewNavigation(): boolean {
    return useIsRouteActive({ to: '/next' });
}
